import React from 'react'
import { SectionCard } from './SectionCard'
import { promotionDisplayLabels } from '../constants'
import styles from './styles.module.css'

function activePromotionLabel(offers) {
  if (!offers) return null
  const activeKey = Object.entries(offers).find(([k, v]) => v === true && k !== 'none')?.[0]
  if (!activeKey) return null
  return promotionDisplayLabels[activeKey] || activeKey.replace(/_/g, ' ')
}

export const PromotionsSection = ({ offers }) => {
  const label = activePromotionLabel(offers)
  if (!label) return null

  return (
    <SectionCard title='Promotions'>
      <div className={styles.readOnlyBlock}>{label}</div>
    </SectionCard>
  )
}
